import ResetPasswordSuccess from '../../components/passwordRecovery/ResetPasswordSuccess';

import React from 'react';
import { bindActionCreators} from 'redux';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import PropTypes from 'prop-types';

class ResetPasswordSuccessContainer extends React.Component {

  componentDidMount() {
    window.setTimeout(() => {
      this.props.push('/');
    }, 3000);
  }

  render() {
    return (
      <ResetPasswordSuccess />
    );
  }
}

ResetPasswordSuccessContainer.propTypes = {
  push: PropTypes.func.isRequired
};

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({
      push
    }, dispatch)
  };
}

export default connect(null, mapDispatchToProps)(ResetPasswordSuccessContainer);
